import React, {useEffect, useState} from "react";
import "./carousel.css";
import ChevronIcon from "../../assets/ChevronIcon";

export function CarouselComponent({children, onIndexChange}) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToNext = () => {
        const newIndex = (currentIndex + 1) % children.length;
        setCurrentIndex(newIndex);
    };

    const goToPrev = () => {
        const newIndex = (currentIndex - 1 + children.length) % children.length;
        setCurrentIndex(newIndex);
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };

    // Notify the parent component of index changes
    useEffect(() => {
        if (onIndexChange) {
            onIndexChange(currentIndex);
        }
    }, [currentIndex, onIndexChange]);

    return (
        <div className="carousel">
            <div className="carouselImages">
                <div className="carouselItems" style={{transform: `translateX(-${currentIndex * 100}%)`}}>
                    {React.Children.map(children, (child, index) => (
                        <div className="carouselItem" key={index}>
                            {child}
                        </div>
                    ))}
                </div>
                <button className="carouselControl left" onClick={goToPrev}>
                    <ChevronIcon className={"chevronIcon left"}/>
                </button>
                <button className="carouselControl right" onClick={goToNext}>
                    <ChevronIcon className={"chevronIcon right"}/>
                </button>
            </div>
            <div className="carouselIndicators">
                {children.map((_, index) => (
                    <span
                        key={index}
                        className={`carouselIndicator ${currentIndex === index ? "active" : ""}`}
                        onClick={() => goToIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
}
